import { ConnectorInfo } from '@blaze-shared/api-contracts-domain';
import { BaseSchema } from '@blaze-shared/schema-domain';
import { FilterWorkflowNode } from '@blaze-shared/workflow-domain';

import { CONDITION_SOURCE_ID, FORMULA_SOURCE_ID } from '../../errors';
import {
  getColumnReferencesFromString,
  getNamedInputReferencesFromString,
  getParamReferencesFromString,
  getTagReferencesFromString,
} from '../../references/get-references-from-string';
import {
  WorkflowNodeColumnReference,
  WorkflowNodeNamedInputReference,
  WorkflowNodeParamReference,
  WorkflowNodeTagReference,
} from '../../references/references.models';
import { BaseWorkflowNode, WorkflowNode } from '../../registry/node.registry';

@WorkflowNode('Filter')
export class FilterNode extends BaseWorkflowNode<FilterWorkflowNode> {
  static readonly FORMULA_SOURCE_ID = FORMULA_SOURCE_ID;
  static readonly CONDITION_SOURCE_ID = CONDITION_SOURCE_ID;

  getColumnReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeColumnReference[] {
    return [
      ...getColumnReferencesFromString(this.node.formula, schemas, FilterNode.FORMULA_SOURCE_ID),
      ...getColumnReferencesFromString(
        this.node.condition,
        schemas,
        FilterNode.CONDITION_SOURCE_ID,
      ),
    ];
  }

  getTagReferences(schemas: Map<string | symbol, BaseSchema>): WorkflowNodeTagReference[] {
    return [
      ...getTagReferencesFromString(this.node.formula, schemas, FilterNode.FORMULA_SOURCE_ID),
      ...getTagReferencesFromString(this.node.condition, schemas, FilterNode.CONDITION_SOURCE_ID),
    ];
  }

  getParamReferences(
    schemas: Map<string | symbol, BaseSchema>,
    connectors: ConnectorInfo[],
  ): WorkflowNodeParamReference[] {
    return [
      ...getParamReferencesFromString(
        this.node.formula,
        schemas,
        connectors,
        FilterNode.FORMULA_SOURCE_ID,
      ),
      ...getParamReferencesFromString(
        this.node.condition,
        schemas,
        connectors,
        FilterNode.CONDITION_SOURCE_ID,
      ),
    ];
  }

  getNamedInputReferences(
    schemas: Map<string | symbol, BaseSchema>,
  ): WorkflowNodeNamedInputReference[] {
    return [
      ...getNamedInputReferencesFromString(
        this.node.formula,
        schemas,
        FilterNode.FORMULA_SOURCE_ID,
      ),
      ...getNamedInputReferencesFromString(
        this.node.condition,
        schemas,
        FilterNode.CONDITION_SOURCE_ID,
      ),
    ];
  }
}
